// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__6J70X","main":"Layout_main__k2ohw"};